import { Inject, Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { Environment } from '../model/environment';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BasicResponse, Auth0Application, SortFilterInterface } from '../..';
import { ApplicationIPAddress } from '../model/application-ipaddress';

export interface ApplicationAPI {
  items: Auth0Application[];
  total_count: number;
}

@Injectable({
  providedIn: 'root',
})
export class Auth0ApplicationService {
  constructor(
    @Inject(ConfigService) private config: Environment,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'PADM')?.url || '';
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }
  private URL;
  headers: HttpHeaders;

  private static handleHTTPError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }

  getApplications(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    sortFilter: SortFilterInterface
  ): Observable<ApplicationAPI> {
    const headers = this.headers;
    if (sortActive === '' || sort === '') {
      sortActive = '0';
      sort = 'asc';
    }
    return this.httpClient
      .post<ApplicationAPI>(
        `${this.URL}/auth0/app/${pageIndex}/${pageSize}/${sortActive}/${sort}`,
        sortFilter,
        { headers }
      )
      .pipe(catchError(Auth0ApplicationService.handleHTTPError));
  }

  updateApplication(app: Auth0Application): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient
      .patch<BasicResponse>(`${this.URL}/auth0/app/${app.clientId}`, app, {
        headers,
      })
      .pipe(catchError(Auth0ApplicationService.handleHTTPError));
  }

  createApplication(app: Auth0Application): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient
      .put<BasicResponse>(`${this.URL}/auth0/app/`, app, { headers })
      .pipe(catchError(Auth0ApplicationService.handleHTTPError));
  }

  getApplication(id: string): Observable<Auth0Application> {
    const headers = this.headers;
    return this.httpClient
      .get<Auth0Application>(`${this.URL}/auth0/app/${id}`, { headers })
      .pipe(catchError(Auth0ApplicationService.handleHTTPError));
  }

  createAR(applicationResource: any) {
    console.log(applicationResource);
    const headers = this.headers;

    return this.httpClient.post<BasicResponse>(
      `${this.URL}/auth0/app/applicationresources`,
      applicationResource,
      { headers }
    );
  }

  addIPAddressOrigin(clientId: string, ipAddress: string): Observable<Auth0Application> {
    const headers = this.headers;
    const applicationIPAddress: ApplicationIPAddress = {
      ipAddress: ipAddress
    }
    return this.httpClient.post<Auth0Application>(`${this.URL}/auth0/app/${clientId}/clientip`, applicationIPAddress, { headers })
      .pipe(catchError(Auth0ApplicationService.handleHTTPError));
  }

  removeIPAddressOrigin(clientId: string, ipAddress: string): Observable<Auth0Application> {
    const headers = this.headers;
    const applicationIPAddress: ApplicationIPAddress = {
      ipAddress: ipAddress
    }
    return this.httpClient.delete<Auth0Application>(`${this.URL}/auth0/app/${clientId}/clientip`, { headers, body: applicationIPAddress })
      .pipe(catchError(Auth0ApplicationService.handleHTTPError));
  }

  toggleIPAddressOrigin(clientId: string) {
    const headers = this.headers;
    return this.httpClient.patch<Auth0Application>(`${this.URL}/auth0/app/${clientId}/toggleipvalidation`, {}, { headers })
      .pipe(catchError(Auth0ApplicationService.handleHTTPError));
  }


}
